export const DisablingWarningDialogTranslations = {
  commentPlaceholder: 'Comment is required',

  suffix: 'disabling-warning',

  apply: 'jbp-planning-disabling-flag-apply',
  cancel: 'jbp-planning-disabling-flag-cancel',
}

export default DisablingWarningDialogTranslations
